import { useMemo } from 'react';
import getConfig from 'next/config';
import useSwr, { preload } from 'swr';
import useSwrInfinite from 'swr/infinite';
import useSwrMutation from 'swr/mutation';
import { fetcher, mutationFetcher } from './utils/fetchers.js';

const basePath = getConfig()?.publicRuntimeConfig?.basePath ?? '';
const api = async (url, {
  body,
  headers = {},
  method
} = {}) => fetcher(url, {
  body,
  headers,
  method
});
const useApi = (url, swrOptions) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate
  } = useSwr(url ? `${basePath}${url}` : null, fetcher, swrOptions);
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate
  };
};
const useInfiniteApi = (getKey, swrOptions) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    setSize,
    size
  } = useSwrInfinite(getKey, fetcher, swrOptions);
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    setSize,
    size
  };
};
const useRepository = (cacheKey, fetchFunction, swrOptions) => {
  const repoFetcher = useMemo(() => fetchFunction.bind(null, ...(swrOptions?.body ?? [])), [swrOptions?.body, fetchFunction]);
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate
  } = useSwr(cacheKey ?? null, repoFetcher, swrOptions);
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate
  };
};
const useInfiniteRepository = (getKey, fetchFunction, swrOptions) => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    setSize,
    size
  } = useSwrInfinite(getKey, fetchFunction, swrOptions);
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    setSize,
    size
  };
};
const useMutateApi = (url, swrOptions) => {
  const {
    data,
    error,
    isMutating,
    reset,
    trigger
  } = useSwrMutation(url ? `${basePath}${url}` : null, mutationFetcher, swrOptions);
  return {
    data,
    error,
    isMutating,
    reset,
    trigger
  };
};
const useMutateRepository = (cacheKey, fetchFunction, swrOptions) => {
  const {
    data,
    error,
    isMutating,
    reset,
    trigger
  } = useSwrMutation(cacheKey ?? null, fetchFunction, swrOptions);
  return {
    data,
    error,
    isMutating,
    reset,
    trigger
  };
};
const preloadData = async (url, fetchFunction) => {
  await preload(fetchFunction ? url : `${basePath}${url}`, fetchFunction ?? fetcher);
};

export { api, preloadData, useApi, useInfiniteApi, useInfiniteRepository, useMutateApi, useMutateRepository, useRepository };
//# sourceMappingURL=frontend.js.map
